import trace from '~/lib/trace';
import React, {useState, useEffect} from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import moment from 'moment';
import isNil from 'lodash/isNil';

import sy from '~/styles';
import {service_request as serviceRequestApi} from '~/api/private';

import {
  Text,
  Pressable,
  LessorPersona,
  DealerPersona,
} from '~/components/controls';

import PropTypes from 'prop-types';

import DoneIcon from '~/images/md-icons/done/materialicons/24px.svg';
import DoneAllIcon from '~/images/md-icons/done_all/materialicons/24px.svg';
import PhotoCameraIcon from '~/images/md-icons/photo_camera/materialicons/24px.svg';
import DocsIcon from '~/images/md-icons/docs/materialsymbolsoutlined/24px.svg';

const Message = (props) => {
  const {
    style,
    content,
    is_photo,
    attachment_name,
    timestamp: message_timestamp,
    message_id,
    request_id,
    user_id,
    user_name,
    dealer_id,
    dealer_name,
    lessor,
    fleet_owner_name,
    is_sent,
  } = props;
  const [isRead, setIsRead] = useState(props.is_read);

  useEffect(() => {
    const touch = async () => {
      await serviceRequestApi.message_read(request_id, message_id);
      setIsRead(true);
    };

    if (message_id) {
      touch().catch(trace);
    }
  }, [message_id, request_id]);

  let duration;
  if (message_timestamp) {
    const timestamp = moment(message_timestamp);
    if (timestamp.isSame(moment(), 'day')) {
      duration = timestamp.format('H:mm');
    } else {
      duration = timestamp.format('D MMMM YYYY');
    }
  }

  return (
    <View style={[sy['flex-row'], sy['overflow-hidden'], {gap: 22}, style]}>
      {dealer_name ? (
        <DealerPersona dealer_id={dealer_id} size={36} />
      ) : (
        <LessorPersona lessor={fleet_owner_name ?? lessor} size={36} />
      )}
      <View style={[sy['flex-1']]}>
        <View
          style={[
            sy['flex-row'],
            sy['items-center'],
            sy['justify-between'],
            sy['pb-1'],
          ]}>
          <View>
            <Text style={[sy.mediumBold, {lineHeight: 16}]}>
              {user_id ? user_name : dealer_name ?? fleet_owner_name ?? lessor}
            </Text>
          </View>
          <View style={[sy['flex-row'], sy['items-center'], sy['gap-2']]}>
            <Text style={[sy.smallRegular, {lineHeight: 14}]}>{duration}</Text>
            {renderMessageStatus({is_read: isRead, is_sent})}
          </View>
        </View>
        <View style={[[sy['flex-row']]]}>
          {renderAttachmentContent({
            is_photo,
            content,
            attachment_name,
          })}
        </View>
      </View>
    </View>
  );
};

const renderMessageStatus = ({is_read, is_sent}) => {
  if (is_read && is_sent) {
    return <DoneAllIcon width={14} height={14} fill="#231fda" />;
  }

  if (is_sent) {
    return <DoneIcon width={14} height={14} fill="#231fda" />;
  }

  return null;
};

const renderAttachmentContent = ({is_photo, content, attachment_name}) => {
  if (isNil(is_photo)) {
    return <Text style={sy.smallRegular}>{content}</Text>;
  }

  if (is_photo) {
    return (
      <>
        <PhotoCameraIcon width={18} height={18} fill="#4a4a49" />
        <Text style={sy.smallRegular}> Foto</Text>
      </>
    );
  }

  return (
    <>
      <View style={sy['shrink-0']}>
        <DocsIcon width={18} height={18} fill="#4a4a49" />
      </View>
      <Text style={[sy.smallRegular, sy.truncate]}> {attachment_name}</Text>
    </>
  );
};

const LessorMessage = (props) => {
  const navigation = useNavigation();
  const {request_id, disabled, onPress, ...rest} = props;

  return (
    <Pressable
      style={[sy['p-4']]}
      disabled={disabled}
      onPress={() => {
        onPress?.();

        navigation.navigate('Chat', {request_id});
      }}>
      <Message request_id={request_id} {...rest} />
    </Pressable>
  );
};
Message.propTypes = {
  style: PropTypes.any,
  content: PropTypes.string,
  is_photo: PropTypes.bool,
  attachment_name: PropTypes.string,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  request_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  user_name: PropTypes.string,
  dealer_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dealer_name: PropTypes.string,
  lessor: PropTypes.string,
  fleet_owner_name: PropTypes.string,
  is_read: PropTypes.bool,
  is_sent: PropTypes.bool,
};

LessorMessage.propTypes = {
  request_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
};

export default LessorMessage;
